import { Css } from '../../utils';
import { typography } from './typography';

export const layout = {
	page: {
		padding: `${Css.pxToRem(24)}`,
		background: '',
	},
	main: {
		maxWidth: '1200px',
		textMaxWidth: '792px',
		margin: {
			tablet: `${Css.pxToRem(24)}`,
			mobile: `${Css.pxToRem(16)}`,
		},
		mobile: {
			textMaxWidth: '100%',
		},
		tablet: {
			textMaxWidth: '100%',
		},
	},
	image: {
		width: '',
		maxWidth: '100%',
		maxHeight: '900px',
		align: 'center',
		padding: '',
		borderRadius: '',
		mobile: {
			width: '',
			maxWidth: '',
			padding: typography.mobile.paragraph.margin,
			borderRadius: '',
		},
		tablet: {
			width: '',
			maxWidth: '',
		},
	},
};
